const menuFunctionalities = [
  {
    name: 'Solicitação de Saída',
    path: '/solicitar_saida',
    permission: 'exit-requests',
    icon: 'assignment_ind'
  },
  {
    name: 'Autorização de Saída',
    path: '/autorizar_saida',
    permission: 'exit-authorization',
    icon: 'assignment_turned_in'
  }
]

export default menuFunctionalities
